var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkToSource(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "link 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ARC_176_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.7596 8.83438C10.6076 8.83438 10.4556 8.77649 10.3398 8.66041C9.41388 7.73446 7.90724 7.73416 6.98099 8.66041C6.74942 8.89227 6.37299 8.89227 6.14142 8.66041C5.90956 8.42855 5.90956 8.05271 6.14142 7.82085C7.5305 6.43148 9.79061 6.43177 11.1794 7.82085C11.4113 8.05271 11.4113 8.42855 11.1794 8.66041C11.0636 8.77649 10.9113 8.83438 10.7596 8.83438Z",
    fill: "#1E285A"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "ARC_175_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.3399 12.2215C9.42755 12.2215 8.51526 11.8741 7.82087 11.1797C7.58901 10.9479 7.58901 10.572 7.82087 10.3402C8.05243 10.1083 8.42887 10.1083 8.66043 10.3402C9.58638 11.2661 11.093 11.2664 12.0193 10.3402C12.2508 10.1083 12.6273 10.1083 12.8588 10.3402C13.0907 10.572 13.0907 10.9479 12.8588 11.1797C12.1641 11.8741 11.2519 12.2215 10.3399 12.2215Z",
    fill: "#1E285A"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "LINE_273_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12.4386 11.3534C12.2866 11.3534 12.1346 11.2955 12.0189 11.1794C11.787 10.9476 11.787 10.5717 12.0189 10.3399L15.3356 7.02317C15.5671 6.79131 15.9436 6.79131 16.1751 7.02317C16.407 7.25503 16.407 7.63087 16.1751 7.86273L12.8584 11.1794C12.7426 11.2955 12.5906 11.3534 12.4386 11.3534Z",
    fill: "#1E285A"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "LINE_272_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M7.44304 16.3492C7.29104 16.3492 7.13904 16.2913 7.02326 16.1752C6.7914 15.9434 6.7914 15.5675 7.02326 15.3356L8.87724 13.4817C9.10881 13.2498 9.48524 13.2498 9.71681 13.4817C9.94867 13.7135 9.94867 14.0894 9.71681 14.3212L7.86282 16.1752C7.74704 16.2913 7.59504 16.3492 7.44304 16.3492Z",
    fill: "#1E285A"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "LINE_271_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M3.24455 12.1508C3.09255 12.1508 2.94055 12.0929 2.82477 11.9768C2.59291 11.745 2.59291 11.3691 2.82477 11.1373L6.14146 7.82087C6.37332 7.58901 6.74946 7.58901 6.98102 7.82087C7.21288 8.05273 7.21288 8.42857 6.98102 8.66043L3.66434 11.9768C3.54826 12.0926 3.39626 12.1508 3.24455 12.1508Z",
    fill: "#1E285A"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "LINE_270_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M9.70305 5.69255C9.55105 5.69255 9.39935 5.63466 9.28327 5.51888C9.05141 5.28702 9.05141 4.91118 9.28327 4.67902L11.1373 2.82474C11.3691 2.59288 11.745 2.59288 11.9771 2.82474C12.209 3.0566 12.209 3.43245 11.9771 3.6646L10.1231 5.51888C10.0071 5.63437 9.85475 5.69255 9.70305 5.69255Z",
    fill: "#1E285A"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "ARC_174_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M5.34374 17.1995C4.42551 17.1995 3.50727 16.858 2.82476 16.1752C1.45913 14.8096 1.45913 12.5026 2.82476 11.137C3.05632 10.9051 3.43276 10.9051 3.66432 11.137C3.89618 11.3688 3.89618 11.7447 3.66432 11.9765C2.7541 12.8867 2.7541 14.4252 3.66432 15.3354C4.57454 16.2456 6.11294 16.2456 7.02316 15.3354C7.25472 15.1035 7.63116 15.1035 7.86272 15.3354C8.09458 15.5672 8.09458 15.9431 7.86272 16.1749C7.18021 16.858 6.26197 17.1995 5.34374 17.1995Z",
    fill: "#1E285A"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "ARC_173_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M15.7555 8.03669C15.6035 8.03669 15.4515 7.9788 15.3357 7.86272C15.1038 7.63086 15.1038 7.25502 15.3357 7.02316C16.2459 6.11294 16.2459 4.57454 15.3357 3.66432C14.4255 2.7541 12.8871 2.7541 11.9768 3.66432C11.7453 3.89618 11.3688 3.89618 11.1373 3.66432C10.9054 3.43246 10.9054 3.05662 11.1373 2.82476C12.5029 1.45913 14.8099 1.45913 16.1755 2.82476C17.5412 4.19038 17.5412 6.4974 16.1755 7.86302C16.0595 7.9788 15.9075 8.03669 15.7555 8.03669Z",
    fill: "#1E285A"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkToSource);
export default __webpack_public_path__ + "static/media/linkToSource.faf25f8a20de244d46998b1dbfa69bf2.svg";
export { ForwardRef as ReactComponent };